import axios from 'axios'
import apiConfig from '../../config/api-config'
import nrLogger from './nrLogger'

const apiUrl = `${apiConfig.apiURL}/v1/inventory/byIdBatch`

const checkInventory = (productId = '') => {
  const body = {
    items: productId.split('|').map(id => Number(id)),
  }
  return axios.post(apiUrl, body, {
    headers: {
      'Content-Type': 'application/json',
      apikey: apiConfig.apiKey,
    },
  })
    .catch(err => {
      nrLogger.error('checkInventoryFail', err)
      throw err
    })
}

export default checkInventory
